import React from "react";

export default ({raffle}) => {
    return (<div>
        <h2>{raffle.name}</h2>
        Your entry for the {raffle.name} raffle has been received.<br/> You will be notified by email if you are selected.
        <br/>
    </div>);
};